import Vue from 'vue';
import { registerDirectives } from 'pdk/infrastructure';
import { default as IdDirective } from './id';


registerDirectives(Vue, [
	IdDirective
]);
